import { Environment } from './global';

export const eYaca: Environment = {
  app_name: 'yaca',
  app_name_real: 'yaca',
  base_url: 'https://api.zidouchat.com',
  base_url_c: 'https://api2.zidouchat.com',
  env_url: '',
  domain: 'zidouzone.com',
  bot_name: '币答小助手',
  app_name_string: '友问币答',
  app_id: 'wxc3bc48b4c40651fd',
  token_name: 'yacaUserToken',
  logo_icon_url: './assets/imgs/yaca/logo_A.png',
  host_url: 'https://wx.zidouad.com',
  logo_loader_icon: './assets/imgs/yaca-loading.gif',
  logo_path:'/assets/imgs/yaca/logo_A.png',
  live_zidou:200,
  shareDirection:'',
  topicFlag:'',
  menu_auth_pc: [
    'statis',
    'batch_sending',
    'auto_reply',
    'sensitive',
    'sensitive-msg',
    'sensitive-list',
    'wallet',
    'events',
    'coin',
    'group_zone',
    'share_task',
    'assistant',
    'staff',
    'role-list',
    'staff-list',
    'sign',
    'remote',
    'chatroom_score'
  ],
  menu_auth_wx: [
    'coin',
    'auto_reply',
    'batch_sending',
    'wallet',
    'events',
    'statis',
    'sensitive',
    'group_zone',
    'share_task',
    'assistant',
    'employee',
    'staff',
    'bibisheng'
  ],
};



// WEBPACK FOOTER //
// ./src/environments/environment.yaca.ts